module.exports = __webpack_public_path__ + "media/images/chat-e460a4c0525851d77dafa7793ef246fb.svg";